<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import ModuleIconLabel from "../components/ModuleIconLabel.svelte";
  import P from "../components/P.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps } from "../utils";

  const license = "projects";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <ModuleIconLabel {license} />
  <H1>The admin-free CRM & ATS</H1>
  <P>
    Manage every client, candidate, and role in one streamlined workspace.
    Projects connects your outreach, engagement, and workflows across
    SourceWhale - so you can focus on building relationships, not admin.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-chart-kanban" {...iconProps} />Track progress and
      move roles forward with drag-and-drop ease
    </Bullet>
    <Bullet>
      <IconScale class="fa-timeline" {...iconProps} />View every email, call,
      and note in one shared timeline
    </Bullet>
    <Bullet>
      <IconScale class="fa-sparkles" {...iconProps} />Let AI draft, summarize,
      and surface next steps automatically
    </Bullet>
  </Bullets>
  <CTAs webpageLink="https://sourcewhale.com/projects" {license} />
</Slide>
